import { observable } from 'mobx'

export default class myProjectsStore {
  @observable data = []
  @observable sessionData = []
  @observable created = false

  updateData(data) {
    this.data = data
  }

  updateSessionData(data) {
    this.sessionData = data
  }

  updateCreated() {
    this.created = true
  }

  updateSessionDataById(id) {
    var index = this.data
      .map(x => {
        return x.id
      })
      .indexOf(id)

    this.sessionData = this.data[index]
  }

  updateDataBySession() {
    var index = this.data
      .map(x => {
        return x.id
      })
      .indexOf(this.sessionData.id)
    this.data[index] = this.sessionData
  }

  deleteSessionById(id) {
    var index = this.data
      .map(x => {
        return x.id
      })
      .indexOf(id)
    this.data.splice(index, 1)
  }
}



// WEBPACK FOOTER //
// ./src/stores/myProjectsStore.js